import { AppUserTag } from '../Tag/AppUserTag';
import { CustomerDetailsCard, DrawerCloseButton } from '@components';
import { useView } from '@hooks';
import { Customer } from '@services';
import { Drawer, Typography } from 'antd';
import React from 'react';
import './CustomerDetailsDrawer.css';

const { Text } = Typography;

interface IProps {
  open: boolean;
  customer: Customer;
  onClose: () => void;
}

/**
 * Everything we hold on a customer - contact details, addresses and activity - opened from the
 * short summary on the order's customer card. The vehicle has a drawer of its own.
 */
export const CustomerDetailsDrawer: React.FC<IProps> = ({ open, customer, onClose }) => {
  const { isMobile } = useView();

  return (
    <Drawer
      title={
        <span style={{ display: 'flex', alignItems: 'center', gap: 10, minWidth: 0 }}>
          <Text strong style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
            {customer.fullname}
          </Text>
          <AppUserTag userId={customer.userId} style={{ margin: 0 }} />
        </span>
      }
      open={open}
      onClose={onClose}
      styles={{ wrapper: { width: isMobile ? '100%' : 800 } }}
      destroyOnHidden
      closable={false}
      extra={<DrawerCloseButton onClick={onClose} />}
    >
      {/* The full card, headerless (the drawer title is the header) and with the activity block. */}
      <div className="customer-details-drawer">
        <CustomerDetailsCard
          customer={customer}
          bordered={false}
          hideHeader
          fixedWidth
          descriptionColumns={isMobile ? 1 : 2}
          descriptionLabelWidth={150}
        />
      </div>
    </Drawer>
  );
};
